module.exports = window.readworks.config;
